module.exports = __webpack_public_path__ + "img/spbu2.6cfd2124.png";